import {cardTitle, container, primaryBtn, warningBtn,} from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

import buttonStyle from "components/CustomButtons/buttonStyle.jsx";

const dlPageStyle = theme => ({
  ...buttonStyle,
  ...customCheckboxRadioSwitch,
  primaryBtn,
  warningBtn,
  container: {
    ...container,
    marginLeft: "0px",
    marginRight: "0px",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
      paddingLeft: "0px",
      paddingRight: "0px",
      width: "calc(100vw - 32px)"
    }
  },
  cardTitleWhite: {
    ...cardTitle,
    color: "#FFFFFF"
  },
  textCenter: {
    textAlign: "center"
  },
  forgotBTN: {
    textAlign: "right",
    marginLeft: '40px'
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },

  wrapper: {
    height: "auto",
    minHeight: "100vh",
    position: "relative",
    top: "0"
  },
  logoFooter: {
    position: "absolute",
    bottom: 0,
    right: 0,
    transition: "all 300ms linear",
    overflow: "hidden",
    opacity: 0.5,
  },
  imgFooter: {
    overflow: "hidden"
  },
  imgDownload:{
    height: "66px",
    margin: "auto",
    marginTop: "8px"
  },
  appCard: {
    padding:"16px",
    display:"flex",
    alignItems: "center",
    flexDirection: "column",
    "&:focus,&:hover": {
      transform:"scale(1.03, 1.03)",
      transitionProperty: "transform",
    },
  },
  transition: {
    transitionDuration:"250ms",
    transitionProperty: "transform",
  },
  containerGrid: {
    marginLeft: "-12px!important"
  },
  fullPage: {
    padding: "10px 0",
    position: "relative",
    minHeight: "100vh",
    minWidth: "100vw",
    display: "flex!important",
    flexGrow:"1",
    margin: "0",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "stretch",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100vh",
    width: "100vw",
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%",
      border: "none !important"
    },
    "&:before": {
      backgroundColor: "rgba(0, 0, 0, 0.3)"
    },
    "&:before,&:after": {
      display: "block",
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      zIndex: "2"
    }
  },
  backdrop: {
    zIndex: 99,
    color: '#fff',
  },
});

export default dlPageStyle;
